import { useCallback, useEffect } from 'react';
import { documentTitleStore, useSubjectSelector } from '../store';
var useDocumentTitle = function() {
    var _useSubjectSelector = useSubjectSelector(documentTitleStore, [
        'title',
        'notificationCount'
    ]), stateTitle = _useSubjectSelector.title, stateCount = _useSubjectSelector.notificationCount;
    useEffect(function() {
        if (stateCount > 0) {
            document.title = "(".concat(stateCount, ") ").concat(stateTitle);
        } else {
            document.title = stateTitle;
        }
        return function() {
            document.title = stateTitle;
        };
    }, [
        stateCount,
        stateTitle
    ]);
    return {
        setTitle: useCallback(function(title) {
            if (title !== null && title !== undefined) {
                documentTitleStore.setTitle(title);
            }
        }, []),
        setNotificationCount: useCallback(function(notificationCount) {
            if (notificationCount !== null && notificationCount !== undefined) {
                documentTitleStore.setNotificationCount(notificationCount);
            }
        }, [])
    };
};
export { useDocumentTitle };
